import styled from "styled-components";
import { Dropdown } from "discover.medical.react-component-library";

export const DropdownMenu = styled(Dropdown)`
  .limitHeight {
    max-height: 40vh;
    overflow-x: hidden;
    overflow-y: auto;
  }
`;
